import { fullDate, relativeTime, useNowTick } from "../lib/time";

export function RelativeTime({ iso }: { iso: string | null | undefined }) {
  const now = useNowTick();
  if (!iso) return null;
  return (
    <time dateTime={iso} title={fullDate(iso)}>
      {relativeTime(iso, now)}
    </time>
  );
}
